module.exports = __webpack_public_path__ + "static/screen-esami-bezels-c038d86237c41c4a86d14b9f195e2856.png";